import * as Styled from './styled';

const Form = Styled.Form;
export const FieldSet = Styled.FieldSet;
export const FormActions = Styled.FormActions;
export const ErrorMessage = Styled.ErrorMessage;
export const SuccessMessage = Styled.SuccessMessage;

export default Form;
